module.exports = __webpack_public_path__ + "static/media/head-partner.17e82e26.svg";